// Action creators extracted from AssessmentModule.js

import {
  UPDATE_ASSESSMENT_IN_REDUX,
  UPDATE_FILTERS,
  SAVE_FIELD_UPDATE_ACTIVITY_STATUS,
  CLEAR_FIELD_UPDATE_ACTIVITY_STATUS,
  UPDATE_AI_DATA_IN_REDUX,
  UPDATE_SHOW_AI_QUICK_TIP,
  SET_AI_EVALUATION_EXPANDED_STATE,
  SET_LTI_ATTACHMENT_DELETED,
} from "./AssessmentConstants";

// Action Creators

export const updateShowAIQuickTip = data => {
  return { type: UPDATE_SHOW_AI_QUICK_TIP, data };
};

export const updateAssessmentInRedux = data => {
  return {
    type: UPDATE_ASSESSMENT_IN_REDUX,
    data,
  };
};

export const updateAIDataInRedux = data => {
  return {
    type: UPDATE_AI_DATA_IN_REDUX,
    data,
  };
};

export const updateFilters = data => {
  return {
    type: UPDATE_FILTERS,
    data,
  };
};

export const saveFieldUpdateActivityStatus = data => {
  return {
    type: SAVE_FIELD_UPDATE_ACTIVITY_STATUS,
    data,
  };
};

export const clearFieldUpdateActivityStatus = data => {
  return {
    type: CLEAR_FIELD_UPDATE_ACTIVITY_STATUS,
    data,
  };
};

export const setAIEvaluationExpandedState = data => {
  return {
    type: SET_AI_EVALUATION_EXPANDED_STATE,
    data,
  };
};

export const setLtiAttachmentDeleted = data => {
  return {
    type: SET_LTI_ATTACHMENT_DELETED,
    data,
  };
};
